import React, { Component } from 'react'
import Page from '../components/Page'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import Card from '../components/Card'
import CardButton from '../components/CardButton'
import Heading from '../components/Heading'
import Logo from '../components/Logo'
import routes from '../routes/routes'
import { Link } from 'react-router-dom';


interface Props extends RouteComponentProps {}

interface State {}

export default class PaymentConfirmation extends Component<Props, State> {
  initialState: State = {}

  constructor (props: Props) {
    super(props)
    this.state = this.initialState
  }

  componentDidMount() {}

  handleLoginClick(){
    this.props.history.push(routes.signIn)
  }

  render () {
      return (
        <Page size='full'>
          <Card className='mt-12'>
        <div className='flex justify-between mb-5'>
          <div>
            <Heading
              text='Welcome to QPRO+ Family!'
              className='text-theme' />
            <div className="text-secondary">
              Thank you for your payment
            </div>
          </div>
          <Logo type='icon' />
        </div>
        <div style={{width: 100}} className="flex justify-center mt-1 gap-4 bg-primary text-white capitalize focus:outline-none block py-2 px-5">
          <Link to="/">Sign In</Link>
        </div>

      </Card>
        </Page>
      );
  }
}
